<div [ngClass]="innerClass">
    <div class="nova__dialog__toolbar">
        <div class="nova__dialog__toolbar__title">
            {{ data.title }}
        </div>
        <div class="nova__dialog__toolbar__controls">
            <button mat-icon-button class="nova__button--icon" [mat-dialog-close]="false">
                <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
            </button>
        </div>
    </div>
    <div mat-dialog-content class="nova__dialog__content">
        <ng-container [ngTemplateOutlet]="data.template">
            {{ data.message }}
        </ng-container>
    </div>
    <div mat-dialog-actions>
        @if (data.confirmText) {
        <button mat-raised-button color="primary" [mat-dialog-close]="data" (click)="confirm()">
            {{ data.confirmText | uppercase }}
        </button>
        }
        @if (data.cancelText) {
        <button mat-raised-button color="default" (click)="cancel()">{{ data.cancelText | uppercase }}</button>
        }
    </div>
</div>